import React, { useEffect, useRef, useState, forwardRef } from "react";

const TooltipCursor = forwardRef(
  (
    {
      children,
      content,
      delay,
      visible = true,
      direction = "right",
      textStyle = {},
    },
    ref
  ) => {
    const [isTooltipVisible, setTooltipVisible] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [showTooltipContent, setShowTooltipContent] = useState(false);

    const tooltipRef = useRef(document.createElement("div"));

    const handleMouseMove = (event) => {
      const { clientX, clientY } = event;

      const tooltipWidth = tooltipRef.current?.offsetWidth || 0;
      const tooltipHeight = tooltipRef.current?.offsetHeight || 0;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      //+12 is added to give a spice between cursor and tooltip
      let tooltipX = clientX + 12;
      let tooltipY = clientY + 12;

      // Logic for tooltip position based on direction
      if (direction === "left") {
        tooltipX = clientX - tooltipWidth - 12; // Open to the left
      }

      // Check if tooltip exceeds the right side of the viewport
      if (tooltipX + tooltipWidth > viewportWidth) {
        tooltipX = clientX - tooltipWidth - 10;
      }

      // Check if tooltip exceeds the left side of the viewport (if direction is left)
      if (direction === "left" && tooltipX < 0) {
        tooltipX = clientX + 12; // Fallback to right if it goes out of bounds
      }

      // Check if tooltip exceeds the bottom of the viewport
      if (tooltipY + tooltipHeight > viewportHeight) {
        tooltipY = viewportHeight - tooltipHeight - 10;
      }

      setTooltipPosition({ x: tooltipX, y: tooltipY });
    };

    const handleMouseEnter = () => {
      setTooltipVisible(true);
      setShowTooltipContent(false);
    };

    const handleMouseLeave = () => {
      setTooltipVisible(false);
    };

    useEffect(() => {
      let timeoutId;

      if (isTooltipVisible) {
        timeoutId = setTimeout(() => {
          setShowTooltipContent(true);
        }, delay);
      }

      return () => {
        clearTimeout(timeoutId);
      };
    }, [isTooltipVisible, delay]);

    return (
      <>
        {React.cloneElement(children, {
          onMouseMove: handleMouseMove,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          ref,
        })}
        {visible && isTooltipVisible && (
          <div
            ref={tooltipRef}
            // break-all class can brack the words
            className={`fixed px-[10px] py-[5px] flex-shrink-0 rounded-[5px] border-[1px] border-solid border-[#F0F0F0] bg-white text-[#8D8D8D]  leading-[24px] font-medium shadow-sm z-10 text-[16px] max-w-md ${
              showTooltipContent ? "opacity-100" : "opacity-0"
            }`}
            style={{
              top: tooltipPosition.y,
              left: tooltipPosition.x,
              ...textStyle,
            }}
          >
            {content}
          </div>
        )}
      </>
    );
  }
);

export default TooltipCursor;
